import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.css'
})
export class TermsAndConditionsComponent {
  @Input() textColor: string = 'text-neutral-800';

  termsAndConditionsURL = environment.termsAndConditions;
}
